const claro = 'Claro';
const entel = 'Entel';
const movistar = 'Movistar';
const virgin = 'Virgin';
const vtr = 'VTR';
const wom = 'Wom';

const OPERATORS = [
  {
    id: claro,
    name: claro,
  },
  {
    id: entel,
    name: entel,
  },
  {
    id: movistar,
    name: movistar,
  },
  {
    id: virgin,
    name: virgin,
  },
  {
    id: vtr,
    name: vtr,
  },
  {
    id: wom,
    name: wom,
  },
];

export const optionMapper = new Map([['mobileOperator', OPERATORS]]);
